import type { Campaign } from '../types/campaign'
import {
  deriveCampaignStatus,
  formatCampaignDate,
  getCampaignStatusLabel,
  getDaysRemainingLabel
} from '../lib/campaign-ui'

import { AppLink } from '@/shared/lib/router'
import { cn } from '@/shared/lib/utils'

interface CampaignListItemProps {
  campaign: Campaign
}

export function CampaignListItem({ campaign }: CampaignListItemProps) {
  const status = deriveCampaignStatus(campaign)
  const statusLabel = getCampaignStatusLabel(status)
  const timeLabel = getDaysRemainingLabel(campaign.ends_at, status)

  return (
    <AppLink
      href={`/campanhas/${campaign.id}`}
      className={cn('clickable-list-item clickable-list-item--warm block')}
    >
      <div className="flex items-center gap-3">
        <img
          src="/icons/throphy.svg"
          alt=""
          className="size-10 shrink-0 drop-shadow-sm"
          aria-hidden
        />
        <div className="min-w-0 grow">
          <p className="truncate font-bold text-[#974319]">{campaign.name}</p>
          <p className="text-sm text-[#7F7FAD]">
            {statusLabel} · até {formatCampaignDate(campaign.ends_at)}
          </p>
          <p className="text-xs font-semibold text-[#c75300]">{timeLabel}</p>
        </div>
        <span className="shrink-0 text-sm font-bold text-jacaranda" aria-hidden>
          →
        </span>
      </div>
    </AppLink>
  )
}
